import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellymotion2',
	friendly_name: 'Motion 2',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'lowBattery'],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'illumination_definitions',
							component: 'motion_illumination_definitions',
						},
						{ title: 'motion_settings', component: 'motion_settings' },
						{ title: 'tamper_sensitivity', component: 'tamper_sensitivity' },
						{ title: 'sleep_time', component: 'sleep_time' },
						{ title: 'temperature_unit', component: 'temperature_unit' },
						{ title: 'temperature_offset', component: 'temperature_offset' },
						{
							title: 'temperature_threshold',
							component: 'temperature_threshold',
						},
					],
				},
				schedule,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
					],
				},
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'led_status_disable', component: 'mos_light_control' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
